import { DEFAULT_ISO_FORMAT, DEFAULT_LOCALE, ISO_TIMEZONE_CUT_VALUE } from './constants';
import { formatDate } from '../format-date/format-date';
export const transformToDefaultFormat = (dateAndTime) => (dateAndTime === null || dateAndTime === void 0 ? void 0 : dateAndTime.substring(0, (dateAndTime === null || dateAndTime === void 0 ? void 0 : dateAndTime.length) - ISO_TIMEZONE_CUT_VALUE)) || ' ';
export function getFormattedDate(dateAndTime, locale) {
    const currentLocale = locale || DEFAULT_LOCALE;
    if (DEFAULT_ISO_FORMAT.test(dateAndTime))
        return formatDate(dateAndTime, 'llll', '', currentLocale);
    const dateFormatted = transformToDefaultFormat(dateAndTime);
    return DEFAULT_ISO_FORMAT.test(dateFormatted) ? formatDate(dateFormatted, 'llll', '', currentLocale) : dateAndTime;
}
